import React from "react";

const MatchmakerLoader = () => {
  return (
    <div className="p-6 border border-popover bg-popover rounded-xl flex flex-col items-center gap-4">
      <img src={"/images/misc/sparkle.gif"} alt="Sparle Gif" />
      <div className="flex flex-col gap-1 items-center">
        <p className="text-black-primary text-base font-semibold leading-6">Finding your perfect match</p>
        <p className="text-grey-2 text-base font-normal leading-6">
          Our AI is analyzing thousands of profiles to find the best team for your project.
        </p>
      </div>
      <div className="w-[412px] p-4 flex gap-4 items-center justify-start bg-green-3 rounded-xl border border-green-2">
        <div className="p-3 bg-green-4 rounded-md">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#00A63E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 12L11 14L15 10" stroke="#00A63E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <p className="text-dark-green text-base">Analyzing requirements</p>
      </div>
    </div>
  )
}

export default MatchmakerLoader;
